import classnames from 'classnames';
import React, { PureComponent } from 'react';

import CheckmarkIcon from '../icons/CheckmarkIcon';

const CSS = require('./Checkbox.module.less');

interface CheckboxProps {
  children?: any;
  iconClassName?: string;
  labelClassName?: string;
  value: any;
  onChange?: any;
  onClick?: (e: any) => void;
  checked: boolean;
  disabled?: boolean;
  indeterminate?: any;
  className?: string;
  readOnly?: boolean;
  withoutHtmlFor?: boolean;
  id?: string;
}

class Checkbox extends PureComponent<CheckboxProps> {
  checkbox = null;

  componentDidMount() {
    const { indeterminate = false } = this.props;
    this.checkbox.indeterminate = indeterminate ? 1 : undefined;
  }

  componentDidUpdate() {
    const { indeterminate = false } = this.props;
    this.checkbox.indeterminate = indeterminate ? 1 : undefined;
  }

  setRef = (c) => (this.checkbox = c);

  render() {
    const {
      children,
      className,
      iconClassName,
      labelClassName,
      value,
      onChange,
      checked,
      disabled,
      withoutHtmlFor,
      id,
      ...rest
    } = this.props;
    return (
      <div
        className={classnames(CSS.CheckboxRow, {
          [className]: className,
          [CSS.CheckboxRowDisabled]: disabled,
        })}
      >
        <div className={CSS.CheckboxWrapper}>
          <input
            ref={this.setRef}
            className={CSS.CheckboxInput}
            checked={checked}
            disabled={disabled}
            id={id || value.toString()}
            type="checkbox"
            value={value}
            onChange={onChange}
            {...rest}
          />
          {checked && (
            <span
              className={classnames(CSS.Checkmark, {
                [iconClassName]: iconClassName,
              })}
            >
              <CheckmarkIcon className={CSS.Icon} width={9} height={7} />
            </span>
          )}
        </div>
        {children && (
          <label
            className={classnames(CSS.CheckboxLabel, {
              [labelClassName]: labelClassName,
            })}
            htmlFor={withoutHtmlFor ? undefined : id || value}
          >
            {children}
          </label>
        )}
      </div>
    );
  }
}

export default Checkbox;
